module.exports = __webpack_public_path__ + "static/media/main_pic_empty.e37f99e9.svg";